

// Transition uitgeschakeld - doet niets meer
const Transition = (Page) => {
  return Page;
};

export default Transition;

